export default __webpack_public_path__ + "static/media/avatar.c6f68d9a.svg";